import { View, Text } from "react-native";
import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useStateContext } from "../lib/context";

const Historial = () => {
  const [orders, setOrders] = useState([]);
  const { currentUser } = useStateContext();

  useEffect(() => {
    getDoc(doc(db, "orders", currentUser)).then((docSnap) => {
      if (docSnap.exists()) {
        setOrders(docSnap.data());
        console.log(orders);
      } else {
        console.log("No such document!");
      }
    });
  }, []);

  return (
    <View>
      <Header title={"Historial"} />
      {/* <Text>{orders.currentOrder.estado}</Text> */}
    </View>
  );
};

export default Historial;
